var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperStyling},[_c('Button',{attrs:{"buttonText":_vm.buttonText,"styling":_vm.styling,"loading":_vm.loading,"disabled":_vm.subscriptionCancelledError},on:{"click":_vm.onCancel}}),(_vm.subscriptionCancelledError)?_c('p',{staticClass:"text-red-700 mt-4"},[_vm._v(" "+_vm._s(_vm.t('ConfirmationV2', 'error'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }